export function getModuleExport(module) {
    const isDefaultExport = typeof module === 'object' && module !== null && 'default' in module;
    return isDefaultExport ? module.default : module;
}
